import { BaseModel } from "sjs-base-model";
import ProductInfoModel from "./ProductInfoModel";
import ConvenantInfoModel from "./ConvenantInfoModel";
import CommissionsDataModel from "./CommissionsDataModel";
import AmountsDataModel from "./AmountsDataModel";
import ValoriModel from "./ValoriModel";
import InsuranceInfoModel from "./InsuranceInfoModel";

export default class EstimatePrintabelModel extends BaseModel {
    // public readonly idEstimateRequest: number = 0;
    // public readonly idRequestType: number = 0;
    // public readonly idEstimate: number = 0;
    // public readonly idDossier: number = 0;
    // public readonly simulationDescription: string = "";
    // public readonly firstName: string = "";
    // public readonly lastName: string = "";
    // public readonly agent: string = "";
    // public readonly gender: string = "";
    // public readonly channel: string = "";
    public readonly source: string = "";
    // public readonly sourceDetail: string = "";
    public readonly lastUpdateDate: Date = new Date();
    public readonly effectiveDate: Date = new Date();
    public readonly hiringDate: Date = new Date();
    public readonly birthDateDescription: string = "";
    public readonly hiringDateDescription: string = "";
    public readonly salary: number = 0;
    // public readonly productInfo: ProductInfoModel = new ProductInfoModel({});
    // public readonly convenantInfo: ConvenantInfoModel = new ConvenantInfoModel({});
    // public readonly commissionsData: CommissionsDataModel = new CommissionsDataModel({});
    // public readonly amountsData: AmountsDataModel = new AmountsDataModel({});
    public readonly idEstimate: string = "";
    public readonly idEstimateRequest: string = "";
    public readonly idPractice: string = "";
    public readonly idSimulation: string = "";
    public readonly simulationName: string = "";
    public readonly idRequestType: number = 0;
    public readonly requestType: string = "";
    public readonly idChannel: number = 0;
    public readonly channel: string = "";
    public readonly sourceType: number = 0;
    public readonly sourceDetail: string = "";
    public readonly sourceDetailDesc: string = "";
    public readonly idSegment: number = 0;
    public readonly segment: string = "";
    public readonly idProduct: number = 0;
    public readonly product: string = "";
    public readonly subLevel: string = "";
    public readonly convention: string = "";
    public readonly atc: string = "";
    public readonly idAtc: number = 0;
    public readonly customerType: string = "";
    public readonly idAdministrativeCategory: number = 0;
    public readonly agent: string = "";
    public readonly idAgent: number = 0;
    public readonly installment: number = 0;
    public readonly duration: number = 0;
    public readonly futureValue: number = 0;
    public readonly commissions: number = 0;
    public readonly amount: number = 0;
    public readonly balance: number = 0;
    public readonly rc: string = "";
    public readonly rv: string = "";
    public readonly estimateDate: string = "";
    public readonly isExpired: boolean = false;
    public readonly firstName: string = "";
    public readonly lastName: string = "";
    public readonly gender: string = "";
    public readonly birthNation: string = "";
    public readonly birthPlace: string = "";
    public readonly birthPlaceCode: string = "";
    public readonly birthCounty: string = "";
    public readonly birthDate: string = "";
    public readonly fiscalCode: string = "";
    public readonly residenceNation: string = "";
    public readonly residencePlaceCode: string = "";
    public readonly residencePlace: string = "";
    public readonly residenceCounty: string = "";
    public readonly residenceAddress: string = "";
    public readonly residenceCivicNumber: string = "";
    public readonly mobilePhone: string = "";
    public readonly mail: string = "";
    public readonly thirdPartiesYearExtinctions: boolean = false;
    public readonly existingExtinctions: number = 0;
    public readonly existingAssignment: boolean = false;
    public readonly tan: number = 0;
    public readonly tanBase: number = 0;
    public readonly teg: number = 0;
    public readonly taeg: number = 0;
    public readonly irr: number = 0;
    public readonly vaCapital: number = 0;
    public readonly stampDuty: number = 0;
    public readonly interestAmount: number = 0;
    public readonly residenceAddressType: string = "";
    public readonly idSignProcess: string = "";
    public readonly idAnag?: number = undefined;
    public readonly typeId?: number = undefined;
    public readonly introText: string = "";
    public readonly bankCommissions: ValoriModel = new ValoriModel({});
    public readonly agentCommissions: ValoriModel = new ValoriModel({});
    public readonly preloadedCommissions: ValoriModel = new ValoriModel({});
    public readonly reportingBankCommissions: ValoriModel = new ValoriModel({});
    public readonly preliminaryCosts: ValoriModel = new ValoriModel({});
    public readonly insuranceInfo: InsuranceInfoModel = new InsuranceInfoModel({});
    public readonly total: number = 0;

    constructor(data: Partial<EstimatePrintabelModel>) {
        super();

        this.update(data);
        this.total = this.balance - this.existingExtinctions;
    }
}
